import React from 'react';
import './styles/partners.css'
import './styles/about.css'
import Ashley from '../assets/HHAshley-17.jpg';
import Angie from '../assets/WhatsApp Image 2025-11-23 at 10.45.22 PM.jpeg';
import Madison from '../assets/c96a6cbd-3100-4c58-bf14-d041a37a9700.jpg';
import Karina from '../assets/thumbnail_Profile Pic_Karina Cheung.png';
import { Link } from 'react-router-dom';

export default function Home() {
    return (
        <section className="partner-landing about-section general">

            <img src={Angie} alt="" className="me" />

            <p className="aboutIntro">
                <h2>Angie Cole</h2>
                <br />
                (she/her)
                <br />
                Master of Social Work
                <br />
                Registered Social Worker
                <br />
            </p>

            <p className="aboutText">
                Hi, I’m Angie — a Social Worker passionate about supporting teens, women, and families through life’s toughest moments. As a mother, and someone personally touched by loss, mental health struggles, and trauma, I understand how complex, transformative, and challenging life can feel. These experiences guide my work — with empathy, honesty, and hope — helping others find meaning and even joy while navigating grief and life’s challenges.
                <br />
                <br />
                I’ve spent nearly two decades supporting teens, young adults, women, and families facing mental health challenges, trauma, separation, and crises. I focus on helping people feel safer, seen, and more resilient during times of change, loss, or stress.
                <br />
                <br />
                My approach is practical, collaborative, and flexible. Together, we’ll explore your story, discover your strengths, and find ways to cope and grow. Fluent in English and French, I aim to create a warm, welcoming space where teens, women, mothers, and families feel supported, heard, and empowered.

                </p>

            <div className="createSesh">
                <Link to="https://inbloomtherapy.janeapp.com/#/staff_member/2" target="_blank">
                    Create Appointment
                </Link>
            </div>

            <img src={Karina} alt="" className="me" />

            <p className="aboutIntro">
                <h2>Wing Lam (Karina) Cheung  </h2>
                <br />
                (she/her)
                <br />
                Master of Social Work
                <br />
                Registered Social Worker
                <br />
                <br />
            </p>




            <p className="aboutText">
                It is okay to feel sad, frustrated, anxious, angry, or lost. Having feelings doesn’t make you a negative person. It makes you human. Whatever you are facing, I am here to offer a safe, non-judgmental space for you to share freely.
                <br />
                <br />
                I acquired a Master of Social Work degree from the University of Toronto with a specialization in health and mental health. I have years of experience supporting youth and adults with mental health challenges and difficult life transitions across school and hospital settings from a person-centered, culturally sensitive approach.
                <br />
                <br />
                I work with young people and parents to cope with anxiety, depression, learning disabilities (dyslexia, autism, and ADHD), emotional dysregulation, grief and bereavement, trauma, immigration adjustment, and chronic illnesses. With the belief that everyone’s healing journey is unique, I take the time to understand your lived experience and pursue a collaborative alliance where you feel validated and empowered. I also value authenticity and connection in relationships. 
                <br />
                <br />
                Received training in Cognitive Behavioural Therapy (CBT), Dialectical Behaviour Therapy (DBT), Acceptance and Commitment Therapy (ACT), Mindfulness, and Emotion-Focused Therapy (EFT), I practice a holistic approach and tailor the therapy sessions that align with your worldviews and preferences. Services can be provided in English, Cantonese, or Mandarin. Let’s embark on this journey of transformation and empowerment together! 
                <br />
                <br />
            </p>

            <div className="createSesh">
                <Link to="https://inbloomtherapy.janeapp.com/#/staff_member/3" target="_blank">
                    Create Appointment
                </Link>
            </div>

        </section>
    );
}